import MediaList from './MediaList.vue';

export { MediaList };

export default {
  MediaList,
};
